/*!
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

export const ANGULAR_DEV = 'https://angular.dev';

export const ANGULAR_LINKS = {
  GITHUB: 'https://github.com/angular/angular',
  X: 'https://x.com/angular',
  MEDIUM: 'https://blog.angular.dev',
  YOUTUBE: 'https://www.youtube.com/angular',
  DISCORD: 'https://discord.gg/angular',
  BLUESKY: 'https://bsky.app/profile/angular.dev',
  STACKOVERFLOW: 'https://stackoverflow.com/questions/tagged/angular',
} as const;
